import React, { forwardRef, useState } from 'react';
import cn from 'classnames';
import BriefDeliveryRoom from './BriefDeliveryRoom';
import MBRModal from '../../../../common/components/MBRModal';

const BriefDelivery = ({ value, rooms, prices, className, onChange }, ref) => {
  const [contentModal, setContentModal] = useState(false);
  const closeModal = () => {
    setContentModal(false);
  };

  const openModal = () => {
    setContentModal(true);
  };

  let multiroomCounter = 0;
  const multiroomDiscountApplied = (room, index) => {
    multiroomCounter = multiroomCounter + (room.name === 'room_styling' ? 0 : 1);
    return multiroomCounter > 1 && room.name !== 'room_styling';
  };

  return (
    <div ref={ref} className={cn('brief_step -delivery', className)}>
      <div className="brief_step-title-wrapper">
        <h2 className="brief_step-title">{'In a hurry? Upgrade to\n express design service.'}</h2>
        <div className="brief_step-note -bigger-mobile">
          <b>10 days </b>
          or 3 weeks
          <br />
          <button type="button" className="plate-select_info" onClick={() => openModal()}>
            More info
          </button>
        </div>
      </div>

      <div className="brief_delivery-sections">
        {rooms.map((room, index) => (
          <BriefDeliveryRoom
            key={room.value}
            value={value}
            prices={prices}
            room={room}
            onChange={onChange}
            multiroomDiscount={multiroomDiscountApplied(room, index)}
          />
        ))}
      </div>

      <MBRModal
        className="-brief"
        visible={contentModal}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick
        buttonClose
      >
        <p>The design process usually takes 3 weeks per room once the brief is fully complete.</p>
        <p>
          If you&apos;re in a hurry don&apos;t worry, we also offer an Express Service that delivers
          your design in a speedy 10 working days.
        </p>
        <p>
          Just remember, we need all your brief information complete so we can get going, this
          process is complete after your first call with your designer.
        </p>
        <p>
          If you book multiple room designs, your designer will work on your projects as a whole,
          one room at a time.
        </p>
      </MBRModal>
    </div>
  );
};

export default forwardRef(BriefDelivery);



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefDelivery/BriefDelivery.js